module.exports = __webpack_public_path__ + "img/help-on-the-way.dddaf7dd.svg";